import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/common/common.service';
import { DataService } from '../../services/data.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
declare var $: any;
import { SnackbarService } from '../../services/snackbar.service';
import { LoginService } from 'src/app/modules/auth/services/login.service';
import { HttpClient } from '@angular/common/http';
 import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  headerLogo: any;
  headerName: any;
  currentPage: any = sessionStorage.getItem('keyname');
  subscription: Subscription = new Subscription();

  //newly added
  @Input() moduleDetails: any = '';
  @Input() menuItems: any[] = [];
  msg: string = '';
  show2FA: boolean = false;
  // headerLogo: string = '';
  clientName: string = '';
  // headerName: string = '';
  headerUrl: string = '';
  moduleUrl: string = '';
  // currentPage: any;
  userName: string = '';
  shortName: string = '';
  userGroup: any[] = [];
  portalLogin: string = '';
  listOfregions: any;
  selected_region: any;
  // subscription: Subscription = new Subscription();
  show: boolean = false;
  dropdownSettings1 :IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 10,
    allowSearchFilter: true,
    enableCheckAll: false 
  };
  constructor(private commonService: CommonService,
    private http: HttpClient,
    private dataService: DataService,
    private router: Router,
    private loginService: LoginService,
    private snackbarService: SnackbarService,) {
    this.getListOfregions()
  }
  ngOnInit(): void {
    this.commonService.readConfigurationsData().subscribe((data: any) => {
      this.userGroup = JSON.parse(sessionStorage.getItem('userGroup'));
      this.headerLogo = data['headerLogoPath'];
      let userData = JSON.parse(sessionStorage.getItem('userData') as string);
      // this.show2FA = userData['2fa_opted'];
      this.clientName = data['plantName'];
      this.moduleUrl = window.location.pathname.split('/')[1];
      this.headerName = data['modules'].find(module => module.routeUrl.includes(this.moduleUrl)).moduleName;
      this.headerUrl = data['modules'].find(module => module.routeUrl.includes(this.moduleUrl)).routeUrl;
      this.router.events.subscribe((routerData: any) => {
        this.passCurrentPage();
        this.moduleUrl = window.location.pathname.split('/')[1];
        this.headerName = data['modules'].find(module => module.routeUrl.includes(this.moduleUrl)).moduleName;
        this.headerUrl = data['modules'].find(module => module.routeUrl.includes(this.moduleUrl)).routeUrl;
      });
      this.subscription.add(this.dataService.getCurrentPage.subscribe(currentPage => {
        if (currentPage.validFlag) {
          this.currentPage = currentPage.currentPage;
        }
      }));
    });
    this.userName = sessionStorage.getItem('userName')
    this.shortName = this.userName.slice(0, 1);
    this.portalLogin = sessionStorage.getItem('userLoggedIn');
    this.router.events.subscribe(observer => {
      if (observer) {
        this.passCurrentPage();
      }
    })
    // this.router.events.subscribe(observer => {
    //   if (observer) {
    //     this.passCurrentPage();
    //   }
    // })

  }
  ngOnChanges() {
    if (this.menuItems.length > 0 && this.moduleDetails) {
      this.passCurrentPage();
    }
  }

  passCurrentPage() {
    if (this.menuItems.length > 0) {
      let url = window.location.href;
      if (url.split('/')[3] === 'vendor-management') {
        this.currentPage = this.menuItems.find((menu: any) => url.split('/')[5].includes(menu.identifier));
      } else {
        this.currentPage = this.menuItems.find((menu: any) => url.split('/')[4].includes(menu.identifier));
      }
      this.currentPage = (this.currentPage) ? this.currentPage.name : '';
      this.dataService.passCurrentPage(this.currentPage, true);
    }
  }
  onMenuClick(page: string, menu: string,path) {
    // this.currentPage = menu
    if (screen.width < 992) {
      let element: any = document.getElementById('navbar-toggler');
      element.click();
    }
    if (page === '2fa') {
      let userData = JSON.parse(sessionStorage.getItem('userData') as string);
      userData.page = 'settings';
      sessionStorage.setItem('userData', JSON.stringify(userData));
      this.router.navigateByUrl('/auth/two-fact-auth');
    }
    this.currentPage = this.menuItems?.find((d: any) => menu.toLowerCase() === d.identifier)?.name;
    this.currentPage = menu
    window.location.assign(path)
  }
  logout() {
    sessionStorage.removeItem('token');
    this.router.navigateByUrl('auth/login');
    // this.loginService.logout().subscribe(
    //   (data: any) => {
    //     if (data['response_code'] === 1) {
    //       if(this.portalLogin == "auth"){
    //         this.loginService.clearData();
    //         this.router.navigateByUrl('auth/logout');
    //       }
    //       else{
    //         this.loginService.clearData();
    //         this.router.navigateByUrl('vendor-auth/logout');
    //       }
    //     }
    //   },
    //   error => {
    //     this.msg = 'Error occured. Please try again.';
    //     this.snackbarService.show(this.msg, true, false, false, false);
    //   },
    //   () => {
    //   }
    // )
  }
  toggle() {
    this.show = !this.show
  }
  getListOfregions() {
    return this.http.get(sessionStorage.getItem('apiUrl') + "config_portal/regions").subscribe((data) => {
      this.listOfregions = data
      if (sessionStorage.getItem('region') == null) {
        this.selected_region = data[0]['name']
        sessionStorage.setItem('region', this.selected_region);
      }
      this.selected_region = sessionStorage.getItem('region')
    })
  }
  refreshPage() {
    if (sessionStorage.getItem('region') != this.selected_region['name']) {
      sessionStorage.removeItem('CompanyId')
    }
    sessionStorage.setItem('region', this.selected_region['name']);
    window.location.reload();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
